import { AfterViewInit, Directive } from '@angular/core';
import { Observable } from 'rxjs';
import { AutoUnsubscribe } from '../../../decorators';
import { ListRange, ListServerPaginationStateModel, LoadAllFacade, SearchCriteria } from '../../../models';
import { ListFilterComponent } from '../../../../ui-kit/list-filter/list-filter.component';
import { ListSearchCriteriaFacade, ListSearchCriteriaType } from '../../../../store/state/list-search-criteria';
import { delay, filter } from 'rxjs/operators';
import { List } from './list';
import { TranslateService } from '@ngx-translate/core';

@Directive()
@AutoUnsubscribe
export abstract class ListServerPaginationWithHistory<BriefType> extends List<BriefType> implements AfterViewInit {
  abstract listDto$: Observable<ListServerPaginationStateModel<BriefType>>;
  protected abstract listFacade: LoadAllFacade;
  protected abstract listFilterComponent: ListFilterComponent;
  protected abstract listType: ListSearchCriteriaType;

  protected constructor(
    private listSearchCriteriaFacade: ListSearchCriteriaFacade,
    translateService: TranslateService,
  ) {
    super(translateService);
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.subscribeToPaginator();
    this.setListFiltersFromHistory();
  }

  protected changeSearchCriteriaAndLoadAllItems(searchCriteria: Partial<SearchCriteria>): void {
    this.listSearchCriteriaFacade.changeSearchCriteriaByListType(searchCriteria, this.listType);
    this.listFacade.loadAll();
  }

  private subscribeToPaginator(): void {
    this.subscriptions.push(
      this.paginator.page.subscribe(({ pageIndex: page, pageSize: size }: { pageIndex: number; pageSize: number }) => {
        this.fetchList({ page, size });
      }),
    );
  }

  private fetchList(listRange: ListRange): void {
    this.listSearchCriteriaFacade
      .getSearchCriteriaByListType(this.listType)
      .subscribe((searchCriteria: SearchCriteria) => {
        this.changeSearchCriteriaAndLoadAllItems({
          ...searchCriteria,
          ...listRange,
        });
      });
  }

  private setListFiltersFromHistory(): void {
    this.listSearchCriteriaFacade
      .getSearchCriteriaByListType(this.listType)
      .pipe(
        delay(0),
        filter(() => Boolean(this.listFilterComponent)),
      )
      .subscribe(({ size: _size, page: _page, ...filterSearchCriteria }: SearchCriteria) => {
        this.listFilterComponent.filtersForm.patchValue(filterSearchCriteria, {
          emitEvent: false,
        });
        this.listFilterComponent.cd.detectChanges();
      });
  }
}
